import React from 'react';
import { warningInfo } from '../lib/warningLevels';

const WarningBadge = ({ level, withLabel = false, className = '' }) => {
  const info = warningInfo(level);
  if (!info) return null;
  return (
    <span
      className={`inline-flex h-7 shrink-0 items-center gap-1 rounded-full px-2.5 text-xs font-black ${info.badge} ${className}`}
      title={info.label}
      data-testid="warning-badge"
      data-level={info.level}
    >
      Niv. {info.level}
      {withLabel && <span className="font-semibold">· {info.label}</span>}
    </span>
  );
};

export default WarningBadge;
